import StampHistoryLayout from './StampHistoryLayout';

export default StampHistoryLayout;
